import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-page-divider',
    templateUrl: './page-divider.component.html',
    styleUrls: ['./page-divider.component.scss'],
    imports: [NgClass]
})
export class PageDividerComponent {

    @Input() public text?: string;
    @Input() public icon?: string = 'fa-solid fa-star';
}
